<script setup lang="ts">
import { computed } from 'vue'

import Rating from './../shared/Rating.vue'

import type { RecipeAggregateRatingParagraph } from '../../utils/paragraph-schema/paragraphs'

const props = defineProps<{
  recipeAggregateRating: RecipeAggregateRatingParagraph['recipeAggregateRating']
}>()

const category = computed(() => props.recipeAggregateRating?.category ?? '')
const aggregate = computed(() => props.recipeAggregateRating?.aggregate)
</script>

<template>
  <div v-if="aggregate?.ratingCount && aggregate.ratingCount > 0 && aggregate?.averageRating && aggregate.averageRating > 0"
       class="bx-content bx-recipe__rating bx-recipe__rating--aggregate">
    <div class="bx-typo--content-continuous-text">
      <p>
        <span class="bx-recipe__rating-count">
          {{ aggregate.ratingCount }} Bewertungen
        </span>
        <span>
          in &bdquo;{{ category }}&ldquo; mit durchschnittlich
        </span>
      </p>
    </div>
    <Rating :average="aggregate.averageRating"
            :average-fraction-digits="1"
            :show-average="true"
            average-postfix="/5 "
            size="responsive"
            :is-recipe-rating="true" />
  </div>
</template>
